import React from 'react';
import {Stack} from '@mui/material';
import {NumberField} from '@base-ui-components/react/number-field';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SCInputLabel from './SCInputLabel';

const SCNumberField = props=>{
    let {
        label,
        error,
        hint,
        size='medium',
        onChange,
        required,
        ...rest
    } = props;
    return <Stack direction="column" gap={1} sx={{width: '100%'}}>
      {label&&<SCInputLabel label={label} required={required}/>}
      <NumberField.Root
        onValueChange={onChange}
        {...rest}
        render={(props, state)=><FormControl
          size={size}
          ref={props.ref}
          disabled={state.disabled}
          required={state.required}
          error={error}
          variant="outlined"
        >
          {props.children}
        </FormControl>}
      >
        <NumberField.Input
          render={(props, state)=><OutlinedInput
            inputRef={props.ref}
            value={+state.inputValue}
            onBlur={props.onBlur}
            onChange={props.onChange}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
            onFocus={props.onFocus}
            slotProps={{input: props}}
            endAdornment={
              <InputAdornment
                position="end"
                sx={{
                  flexDirection: 'column',
                  maxHeight: 'unset',
                  alignSelf: 'stretch',
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                  ml: 0,
                  '& button': {
                    py: 0,
                    flex: 1,
                    borderRadius: 0.5,
                  },
                }}
              >
                <NumberField.Increment
                  render={<IconButton size={size} aria-label="Increase" />}
                >
                  <KeyboardArrowUpIcon
                    fontSize={size}
                    sx={{ transform: 'translateY(2px)' }}
                  />
                </NumberField.Increment>

                <NumberField.Decrement
                  render={<IconButton size={size} aria-label="Decrease" />}
                >
                  <KeyboardArrowDownIcon
                    fontSize={size}
                    sx={{ transform: 'translateY(-2px)' }}
                  />
                </NumberField.Decrement>
              </InputAdornment>
            }
            sx={{ pr: 0 }}
          />}
        />
        {hint&&<FormHelperText>{hint}</FormHelperText>}
      </NumberField.Root>
    </Stack>;
};

export default SCNumberField;
